<template>
  <div class="login_bg">
    <div
      style="
        margin-left: 68%;
        display: flex;
        flex-direction: column;
        padding: 5% 5% 5% 5%;
        align-items: center;
        overflow: hidden;
      "
    >
      <el-image
        :src="require('@/assets/images/logo.png')"
        fit="fill"
        style="width: 50%"
      ></el-image>
      <ul
        style="
          font-size: 1.8em;
          font-weight: 550;
          text-align: center;
          color: #004890;
          margin-top: 2vh;
        "
      >
        左才右财薪酬管理系统
      </ul>
      <el-form
        ref="formDom"
        label-width="0"
        style="width: 100%"
        :model="state.model"
      >
        <el-form-item
          label=""
          prop="Account"
          :rules="[
            {
              required: true,
              message: '请填写帐号',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="state.model.Account"
            size="large"
            style="margin-top: 5vh; height: 7vh; font-size: 16px"
          >
            <template #prefix><text>账号：</text></template>
          </el-input>
        </el-form-item>
        <el-form-item
          label=""
          prop="Password"
          :rules="[
            {
              required: true,
              message: '请填写密码',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="state.model.Password"
            type="password"
            size="large"
            style="height: 7vh; font-size: 16px"
          >
            <template #prefix><text>密码：</text></template>
          </el-input>
        </el-form-item>
        <el-form-item
          label=""
          prop="Captcha"
          :rules="[
            {
              required: true,
              message: '请填写验证码',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="state.model.Captcha"
            size="large"
            style="height: 7vh; font-size: 16px"
            class="captcha-input"
            placeholder="验证码"
          >
            <template #append>
              <div
                style="
                  width: 140px;
                  height: calc(7vh - 2px);
                  background-color: #fff;
                  border-left: 0;
                  margin-right: 1px;
                "
              >
                <el-image
                  :src="state.imgModel.image"
                  style="height: 100%; cursor: pointer"
                  @click="onLoadCaptcha()"
                  fit="fill"
                ></el-image>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox
            v-model="state.model.Save"
            label="记住账号"
            size="large"
          />
        </el-form-item>
        <el-form-item label="">
          <el-button
            style="width: 100%; height: 7vh; font-size: 18px"
            type="primary"
            @click="onSubmit"
            color="#004890"
            size="large"
          >
            登&nbsp;&nbsp;&nbsp;&nbsp;录
          </el-button>
        </el-form-item>
      </el-form>
      <div style="text-align: center; color: #a2a2a2; font-size: 12px">
        © 2021 xyoa.com, Inc. 保留所有权利 皖ICP备11012359号-4
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
import { captcha, judgeLogin } from "@/http/api";

export default {
  setup() {
    const formDom = ref(null);
    const router = useRouter();
    const state = reactive({
      model: {},
      imgModel: {},
    });
    onMounted(() => {
      const account = localStorage.getItem("account");
      if (account) {
        state.model.Account = account;
        state.model.Save = true;
      }
      onLoadCaptcha();

      //绑定监听事件
      window.addEventListener("keydown", keyDown);
    });

    const onLoadCaptcha = () => {
      captcha().then((res) => {
        if (res.status == 200) state.imgModel = res.data.data;
      });
    };

    onUnmounted(() => {
      //销毁事件
      window.removeEventListener("keydown", keyDown, false);
    });

    //点击回车键登录
    const keyDown = (e) => {
      if (e.keyCode == 13) {
        onSubmit();
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          judgeLogin({
            phone: state.model.Account,
            password: state.model.Password,
            captcha: state.model.Captcha,
            captcha_key: state.imgModel.captcha_key,
            captcha_value: state.imgModel.captcha_value,
          })
            .then((res) => {
              if (res.status == 200) {
                if (state.model.Save)
                  localStorage.setItem("account", state.model.Account);
                else localStorage.removeItem("account");

                const { data } = res.data;
                localStorage.setItem("token", data.token);
                localStorage.removeItem("navData");
                router.push("/");
              } else {
                state.imgModel = {};
                delete state.model.Captcha;
                onLoadCaptcha();
              }
            })
            .catch(() => {
              state.imgModel = {};
              delete state.model.Captcha;
              onLoadCaptcha();
            });
        }
      });
    };
    return { state, onSubmit, formDom, onLoadCaptcha };
  },
};
</script>
<style scoped>
.login_bg {
  width: 100vw;
  height: 100vh;
  display: flex;
  background-image: url("../../assets/images/login.png");
  background-size: 75% auto;
  background-position: left; /* 背景图片居中显示 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-attachment: fixed;
}
</style>
<style lang="less">
.captcha-input {
  .el-input-group__append {
    padding: 0 !important;
  }
}
</style>
